var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgActionBold = function SvgActionBold(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.47243 15.9532C5.54298 15.9532 5 15.4102 5 14.4627V5.53421C5 4.5879 5.54178 4.04492 6.47243 4.04492H10.6863C13.0327 4.04492 14.4558 5.18025 14.4558 7.04035C14.4558 8.36469 13.5011 9.41213 12.1105 9.59272V9.66616C13.7973 9.74803 15 10.9255 15 12.5388C15 14.6048 13.3783 15.9544 10.8271 15.9544H6.47243V15.9532ZM7.96292 8.95824H9.57621C10.8103 8.95824 11.5423 8.40562 11.5423 7.4834C11.5423 6.59489 10.8765 6.07719 9.7568 6.07719H7.96292V8.95703V8.95824ZM7.96292 13.945H9.88924C11.2714 13.945 11.9865 13.3767 11.9865 12.3233C11.9865 11.2951 11.2136 10.7341 9.81459 10.7341H7.96292V13.945Z",
    fill: "white"
  }))));
};
export default SvgActionBold;